import { render, staticRenderFns } from "./resourceDetail.vue?vue&type=template&id=1013bfe2&scoped=true"
import script from "./resourceDetail.vue?vue&type=script&lang=js"
export * from "./resourceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013bfe2",
  null
  
)

export default component.exports